export default __webpack_public_path__ + "static/media/icon.d0974ca5.svg";